import { createAPI } from "../apisServer";

import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("urlAsaas");

const reqCardToken = {
	createPayInvoiceCard: async function (body) {
		return apiServer
			.post("asaas/v1/createpayinvoice/card", body, {
				headers: {
					banco: banco,
				},
			})

			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	insert: async function (body) {
		return apiServer
			.post("asaas/v1/card-token", body, {
				headers: {
					banco: banco,
				},
			})

			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqCardToken;
